import React from "react";
import { Card, Box, Typography, CardContent, Stack, Avatar } from "@mui/material";
import { UserClaimsService } from "../../../services/currentUserService/currentUserService";

interface UserDetailsPanelProps {
    name: string;
    pic: string;
}
const UserDetailsPanel: React.FC<UserDetailsPanelProps> = (props) => {
    const claimsService = new UserClaimsService();
    const [role] = React.useState<string>(claimsService.GetCurrentUserGroup());
    const [email] = React.useState<string>(
        claimsService.GetCurrentUserEmail?.() || "Unknown Email Address"
    );
    const [appRoles] = React.useState<string>(claimsService.GetCurrentUserRoleNames?.().join(", "));

    return (
        <Card sx={{ mb: 3, backgroundColor: "#fff", p: 0, boxShadow: "none" }}>
            <Box
                sx={{
                    backgroundColor: "#2f5f95",
                    color: "#fff",
                    px: 2,
                    py: 1,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                }}
            >
                <Typography variant="body2" fontWeight="bold">
                    Account Info
                </Typography>
            </Box>
            <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar
                        alt={props.name}
                        src={props.pic}
                        sx={{ width: 56, height: 56, fontSize: 24 }}
                    >
                        {props.name}
                    </Avatar>
                    <Box>
                        <Typography variant="body2" fontWeight="bold">
                            {props.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {email}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {role}
                        </Typography>
                        {appRoles !== "" ? (
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    wordBreak: "break-word",
                                    maxWidth: 180,
                                    display: "block",
                                    cursor: "pointer",
                                }}
                            >
                                {appRoles}
                            </Typography>
                        ) : null}
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default UserDetailsPanel;
